import React from "react";

import { Box, Typography } from "@mui/material";
import { useMediaQuery, useTheme } from '@mui/material';

interface Props {
    value: number
    onChange?: any
    token: string
    img: any
    type: string
    balance: string
    setPercent?: any
    onMax?: () => void
}

const inputStyle: any = {
    color: "#ffe9a3",
    width: "100%",
    position: "relative",
    fontWeight: 500,
    outline: "none",
    borderTop: "none",
    borderRight: "none",
    borderLeft: "none",
    borderImage: "initial",
    flex: "1 1 auto",
    fontSize: "1.6rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    padding: "0px 0.5rem",
    appearance: "textfield",
    height: "48px",
    background: "rgba(44,32,16,0.55)",
    borderBottom: "2px solid #ffe9a3aa",
    marginRight: "8px",
    borderRadius: "10px 10px 0 0",
    boxShadow: "0 0 8px 0 #ffe9a355, 0 2px 8px 0 #7d501455",
    backdropFilter: "blur(4px)",
}

const TokenSwapInput = ({ value, onChange, token, img, type, balance, setPercent, onMax }: Props) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Adjust 'sm' as 

    const selectAll = () => {

    }

    return (
        <Box>
            <Box sx={{ display: "flex", alignItems: "center", color: "white", background: "rgba(44,32,16,0.32)", borderRadius: "12px", boxShadow: "0 2px 12px #ffe9a344", px: 1, py: 0.5, mb: 0.5, backdropFilter: "blur(2px)" }}>
                <input style={{ ...inputStyle, fontSize: isMobile ? "1.1rem" : "1.6rem" }} placeholder="0.0" value={value} onChange={onChange} disabled={type == "receive"} pattern="^([0-9]+(\.?[0-9]?[0-9]?d{0, 2}?))" />
                {type === "sell" && onMax && (
                    <button
                        type="button"
                        onClick={onMax}
                        style={{
                            margin: '0 10px',
                            padding: '4px 12px',
                            background: 'linear-gradient(90deg, #ffe9a3 0%, #7d5014 100%)',
                            color: '#3a2609',
                            border: 'none',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: isMobile ? '0.85rem' : '1rem',
                            cursor: 'pointer',
                            boxShadow: '0 0 8px 1px #ffe9a3a0',
                            transition: 'all 0.18s cubic-bezier(.4,2,.3,1)',
                        }}
                    >
                        MAX
                    </button>
                )}
                <Box sx={{ alignItems: "center", width: "60%", fontWeight: 500 }}>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Box sx={{ width: { xs: "22px", sm: "26px", md: "32px" }, marginRight: "6px" }}><img style={{ display: "flex", alignItems: "center" }} src={img} /></Box>
                        <Typography id="modal-modal-title" variant="subtitle1" component="p" sx={{ fontWeight: 700, fontSize: { xs: "0.98rem", sm: "1.08rem", md: "1.18rem" }, color: "#ffe9a3", letterSpacing: 0.5 }}>
                            {token}
                        </Typography>
                    </Box>
                    <Box sx={{ width: "100%", mt: 0.5 }} >
                        <p style={{ whiteSpace: "nowrap", padding: 0, margin: 0, fontSize: '0.82rem', color: '#ffe9a3bb' }}>Balance : {balance}</p>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default TokenSwapInput;